import { Tooltip } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { BEHAVIOUR_LABELS } from '../../../common/constants';
import CommonTable from '../../../components/CommonTable';

/**
 * MyAttendanceView renders a flat, read-only list of the current user's own
 * incidents (one row per employee/month/behaviour), sourced from myAttendanceIncidents.
 */
function MyAttendanceView({ data, loading, onChange, paginationConfig }) {
  const columns = [
    {
      title: 'Month',
      key: 'month',
      width: 140,
      render: (_, record) =>
        dayjs(`${record.year}-${record.month}-01`).format('MMMM YYYY'),
    },
    {
      title: 'Behaviour',
      key: 'behaviourKey',
      width: 160,
      render: (_, record) =>
        BEHAVIOUR_LABELS[record.behaviourKey] || record.behaviourKey,
    },
    {
      title: 'Raw',
      dataIndex: 'rawCount',
      key: 'rawCount',
      align: 'center',
      width: 80,
    },
    {
      title: 'Genuine',
      dataIndex: 'excusedCount',
      key: 'excusedCount',
      align: 'center',
      width: 90,
    },
    {
      title: 'Effective',
      dataIndex: 'effectiveCount',
      key: 'effectiveCount',
      align: 'center',
      width: 90,
    },
    {
      title: 'Genuine By',
      key: 'excusedByUser',
      width: 160,
      render: (_, record) =>
        record.excusedByUser
          ? `${record.excusedByUser.firstName} ${record.excusedByUser.lastName}`
          : '—',
    },
    {
      title: 'Reason',
      dataIndex: 'excuseReason',
      key: 'excuseReason',
      render: (value) =>
        value ? <Tooltip title={value}>{value}</Tooltip> : '—',
    },
    {
      title: 'Logged At',
      key: 'loggedAt',
      width: 130,
      render: (_, record) =>
        record.loggedAt ? dayjs(record.loggedAt).format('DD MMM YYYY') : '—',
    },
  ];

  return (
    <CommonTable
      size="small"
      bordered
      columns={columns}
      data={data || []}
      loadingData={loading}
      rowKey={(obj) => obj?.id}
      onChange={onChange}
      paginationConfig={paginationConfig}
    />
  );
}

export default MyAttendanceView;
